import { get } from 'lodash/fp';

export const MIN = 'min';
export const MAX = 'max';

interface Option {
  name: string;
  value: string;
  label: string;
}

type GetMinMaxOptions = (args: {
  options: Array<Option>;
  type: 'min' | 'max';
  compareValue: string;
  value: string;
}) => Array<Option>;

const getMinMaxOptions: GetMinMaxOptions = ({
  options,
  type,
  compareValue,
  value,
}) => {
  const isMin = type === MIN;

  const finalCompareValue =
    compareValue === undefined ? get([isMin ? MAX : MIN], value) : compareValue;

  if (!finalCompareValue) {
    return options;
  }

  const finalCompareValueNum = Number(finalCompareValue);

  if (isMin) {
    return options.filter(({ value }) => {
      return Number(value) <= finalCompareValueNum || Number(value) === 0;
    });
  }

  return options.filter(({ value }) => {
    return Number(value) >= finalCompareValueNum || Number(value) === 0;
  });
};

export default getMinMaxOptions;
